import React from "react";
import { Box, Container, Typography, Link as MuiLink } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import CivixButton from "../components/ui/CivixButton";
import { FONT_PRIMARY, FONT_WEIGHT } from "../theme/fonts";

const SUPPORT_EMAIL = "privacy@civixthread.com";

export default function SupportDeleteAccountPage() {
  return (
    <Box
      component="main"
      sx={{
        bgcolor: "var(--root-background, #f8f9fa)",
        py: { xs: 5, md: 8 },
        px: { xs: 2, md: 3 },
      }}
    >
      <Container maxWidth="sm" disableGutters>
        <Box sx={{ textAlign: "center", mb: { xs: 3, md: 4 } }}>
          <Typography
            component="h1"
            sx={{
              fontFamily: FONT_PRIMARY,
              fontWeight: FONT_WEIGHT.extraBold,
              fontSize: { xs: 28, md: 40 },
              letterSpacing: "-0.02em",
              lineHeight: 1.15,
              color: "var(--black-color)",
              mb: 1.5,
            }}
          >
            Delete your CivixThread account
          </Typography>
          <Typography
            sx={{
              fontFamily: FONT_PRIMARY,
              fontSize: { xs: 15, md: 17 },
              lineHeight: 1.65,
              color: "var(--dna-color-palette-black-400)",
            }}
          >
            You can permanently delete your account from the website or mobile app. Deletion removes your
            profile, posts, comments, and uploaded media.
          </Typography>
        </Box>

        <Box
          sx={{
            bgcolor: "var(--join-surface-elevated, #ffffff)",
            border: "1px solid var(--join-border-muted, #e4e4e4)",
            borderRadius: "var(--radius-card, 12px)",
            boxShadow: "var(--join-shadow-elevated)",
            p: { xs: 3, md: 4 },
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontFamily: FONT_PRIMARY,
              fontWeight: FONT_WEIGHT.extraBold,
              fontSize: { xs: 18, md: 20 },
              color: "#0f172a",
              mb: 1.5,
            }}
          >
            Delete from the website
          </Typography>
          <Typography sx={{ fontSize: 15, color: "#334155", lineHeight: 1.65, mb: 2 }}>
            Sign in to your account, then open the delete account page. You will review what will be
            removed, confirm any billing changes, and verify your identity before deletion.
          </Typography>
          <CivixButton component={RouterLink} to="/account/delete" sx={{ mb: 3 }}>
            Go to delete account
          </CivixButton>

          <Typography
            component="h2"
            sx={{
              fontFamily: FONT_PRIMARY,
              fontWeight: FONT_WEIGHT.extraBold,
              fontSize: { xs: 18, md: 20 },
              color: "#0f172a",
              mb: 1.5,
              mt: 1,
            }}
          >
            Delete from the mobile app
          </Typography>
          <Typography sx={{ fontSize: 15, color: "#334155", lineHeight: 1.65, mb: 2 }}>
            Open <strong>Account</strong> from your dashboard, scroll down, and tap <strong>Delete account</strong>.
            Follow the guided steps to verify your identity and confirm deletion.
          </Typography>

          <Typography
            component="h2"
            sx={{
              fontFamily: FONT_PRIMARY,
              fontWeight: FONT_WEIGHT.extraBold,
              fontSize: { xs: 18, md: 20 },
              color: "#0f172a",
              mb: 1.5,
              mt: 1,
            }}
          >
            Need help?
          </Typography>
          <Typography sx={{ fontSize: 15, color: "#334155", lineHeight: 1.65 }}>
            Email{" "}
            <MuiLink href={`mailto:${SUPPORT_EMAIL}`} sx={{ color: "#047857", fontWeight: 600 }}>
              {SUPPORT_EMAIL}
            </MuiLink>{" "}
            if you cannot access your account or need assistance with deletion.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}
